const api = {
    getActivityInfo: "/mk/app/collectionActivity/getActivityDetail",
    // onekeyCollection: "/mk/app/commodityCouponGiftBag/onekeyCollection",
    onekey2Collection: "/mk/app/commodityCouponGiftBag/onekey2Collection",
    getTakeStatusByBadId: "/mk/app/commodityCouponGiftBag/getTakeStatusByBadId",
    getCommodityAgreementByType: "/mk/app/commodityAgreement/getCommodityAgreementByType",

};

export default api;
